export const blockedEmailDomains: string[] = [
  '10minutemail.com',
  '10minutemail.net',
  '2prong.com',
  '30minutemail.com',
  '33mail.com',
  '3d-game.com',
  '4warding.com',
  '4warding.net',
  '4warding.org',
  '7tags.com',
  'airmail.cc',
  'anonbox.net',
  'anonymbox.com',
  'antichef.com',
  'antichef.net',
  'antispam.de',
  'bccto.me',
  'beefmilk.com',
  'binkmail.com',
  'bio-muesli.net',
  'bobmail.info',
  'bodhi.lawlita.com',
  'bofthew.com',
  'brefmail.com',
  'broadbandninja.com',
  'bumpymail.com',
  'burn.sx',
  'buymoreplays.com',
  'byom.de',
  'c2.hu',
  'card.zp.ua',
  'casualdx.com',
  'cek.pm',
  'centermail.com',
  'centermail.net',
  'chacuo.net',
  'chipsx.de',
  'clrmail.com',
  'cool.fr.nf',
  'correo.blogos.net',
  'cosmorphis.com',
  'courriel.fr.nf',
  'courrieltemporaire.com',
  'crapmail.org',
  'cust.in',
  'dacoolest.com',
  'dandikmail.com',
  'dayrep.com',
  'dcemail.com',
  'deadaddress.com',
  'deadspam.com',
  'despam.it',
  'despammed.com',
  'devnullmail.com',
  'dfgh.net',
  'digitalsanctuary.com',
  'discardmail.com',
  'discardmail.de',
  'disposableaddress.com',
  'disposableemailaddresses.com',
  'disposableinbox.com',
  'dispose.it',
  'dispostable.com',
  'dm.am',
  'dodgeit.com',
  'dodgit.com',
  'dodgit.org',
  'donemail.ru',
  'dontreg.com',
  'dontsendmespam.de',
  'dump-email.info',
  'dumpandjunk.com',
  'dumpmail.de',
  'dumpyemail.com',
  'e-mail.com',
  'e-mail.org',
  'e4ward.com',
  'easytrashmail.com',
  'einrot.de',
  'einrot.tk',
  'eintagsmail.de',
  'email60.com',
  'emaildienst.de',
  'emailgo.de',
  'emailias.com',
  'emailinfive.com',
  'emailmiser.com',
  'emailsensei.com',
  'emailtemporar.ro',
  'emailtemporario.com.br',
  'emailto.de',
  'emailwarden.com',
  'emailx.at.hm',
  'emailxfer.com',
  'emz.net',
  'enterto.com',
  'ephemail.net',
  'etranquil.com',
  'etranquil.net',
  'etranquil.org',
  'evopo.com',
  'explodemail.com',
  'fakeinbox.com',
  'fakemailz.com',
  'fakemail.fr',
  'fansworldwide.de',
  'fantasymail.de',
  'fightallspam.com',
  'filzmail.com',
  'fivemail.de',
  'fleckens.hu',
  'frapmail.com',
  'freemails.cf',
  'freemails.ga',
  'freemails.ml',
  'freundin.ru',
  'fux0ringduh.com',
  'garliclife.com',
  'get-mail.cf',
  'get-mail.ga',
  'get-mail.ml',
  'get-mail.tk',
  'get2mail.fr',
  'getairmail.com',
  'getmails.eu',
  'getonemail.com',
  'getonemail.net',
  'ghosttexter.de',
  'girlsundertheinfluence.com',
  'gishpuppy.com',
  'gmal.com',
  'gmial.com',
  'gowikibooks.com',
  'gowikicampus.com',
  'gowikifilms.com',
  'gowikigames.com',
  'gowikimusic.com',
  'gowikinetwork.com',
  'gowikitravel.com',
  'gowikitv.com',
  'great-host.in',
  'greensloth.com',
  'grr.la',
  'gsrv.co.uk',
  'guerillamail.biz',
  'guerillamail.com',
  'guerillamail.de',
  'guerillamail.info',
  'guerillamail.net',
  'guerillamail.org',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.info',
  'guerrillamail.net',
  'guerrillamail.org',
  'h.mintemail.com',
  'h8s.org',
  'haltospam.com',
  'harakirimail.com',
  'hat-geld.de',
  'hatespam.org',
  'herp.in',
  'hidemail.de',
  'hidzz.com',
  'hmamail.com',
  'hochsitze.com',
  'hopemail.biz',
  'hotpop.com',
  'hulapla.de',
  'ieatspam.eu',
  'ieatspam.info',
  'ieh-mail.de',
  'ikbenspamvrij.nl',
  'imails.info',
  'inbax.tk',
  'inbox.si',
  'inboxalias.com',
  'inboxclean.com',
  'inboxclean.org',
  'inboxproxy.com',
  'incognitomail.com',
  'incognitomail.net',
  'incognitomail.org',
  'insorg-mail.info',
  'instant-mail.de',
  'instantemailaddress.com',
  'ipoo.org',
  'irish2me.com',
  'iwi.net',
  'jetable.com',
  'jetable.fr.nf',
  'jetable.net',
  'jetable.org',
  'jnxjn.com',
  'jourrapide.com',
  'jsrsolutions.com',
  'junk1e.com',
  'kaspop.com',
  'keepmymail.com',
  'killmail.com',
  'killmail.net',
  'klassmaster.com',
  'klzlk.com',
  'koszmail.pl',
  'kurzepost.de',
  'lawlita.com',
  'letthemeatspam.com',
  'lhsdv.com',
  'lifebyfood.com',
  'link2mail.net',
  'litedrop.com',
  'lol.ovpn.to',
  'lolfreak.net',
  'lookugly.com',
  'lopl.co.cc',
  'lortemail.dk',
  'lr78.com',
  'lroid.com',
  'lukop.dk',
  'm21.cc',
  'maboard.com',
  'mail-filter.com',
  'mail-temporaire.fr',
  'mail.by',
  'mail.mezimages.net',
  'mail2rss.org',
  'mail333.com',
  'mail4trash.com',
  'mailbidon.com',
  'mailbiz.biz',
  'mailblocks.com',
  'mailcatch.com',
  'maildrop.cc',
  'maildrop.cf',
  'maildrop.ga',
  'maildrop.ml',
  'maildu.de',
  'maileater.com',
  'mailexpire.com',
  'mailfa.tk',
  'mailforspam.com',
  'mailfree.ga',
  'mailfree.ml',
  'mailfreeonline.com',
  'mailguard.me',
  'mailin8r.com',
  'mailinater.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'mailinator2.com',
  'mailincubator.com',
  'mailismagic.com',
  'mailmetrash.com',
  'mailmoat.com',
  'mailnator.com',
  'mailnesia.com',
  'mailnull.com',
  'mailorg.org',
  'mailpick.biz',
  'mailrock.biz',
  'mailscrap.com',
  'mailshell.com',
  'mailsiphon.com',
  'mailtemp.info',
  'mailtome.de',
  'mailtothis.com',
  'mailtrash.net',
  'mailtv.net',
  'mailtv.tv',
  'mailzilla.com',
  'mailzilla.org',
  'makemetheking.com',
  'manybrain.com',
  'mbx.cc',
  'mega.zik.dj',
  'meltmail.com',
  'messagebeamer.de',
  'mezimages.net',
  'mierdamail.com',
  'mintemail.com',
  'mjukglass.nu',
  'mobi.web.id',
  'moburl.com',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'msa.minsmail.com',
  'mt2009.com',
  'mt2014.com',
  'mycard.net.ua',
  'mycleaninbox.net',
  'myemailboxy.com',
  'mymail-in.net',
  'mymailoasis.com',
  'mypartyclip.de',
  'mypunkname.com',
  'myspaceinc.com',
  'myspaceinc.net',
  'myspaceinc.org',
  'myspacepimpedup.com',
  'myspamless.com',
  'mytrashmail.com',
  'nabuma.com',
  'neomailbox.com',
  'nepwk.com',
  'nervmich.net',
  'nervtmich.net',
  'netmails.com',
  'netmails.net',
  'netzidiot.de',
  'neverbox.com',
  'no-spam.ws',
  'noblepioneer.com',
  'nomail.xl.cx',
  'nomail2me.com',
  'nomorespamemails.com',
  'nonspam.eu',
  'nonspammer.de',
  'noref.in',
  'nospam.ze.tc',
  'nospam4.us',
  'nospamfor.us',
  'nospammail.net',
  'notmailinator.com',
  'notsharingmy.info',
  'nowhere.org',
  'nowmymail.com',
  'nwldx.com',
  'objectmail.com',
  'obobbo.com',
  'odnorazovoe.ru',
  'oneoffemail.com',
  'onewaymail.com',
  'onlatedotcom.info',
  'online.ms',
  'oopi.org',
  'opayq.com',
  'ordinaryamerican.net',
  'otherinbox.com',
  'ovpn.to',
  'owlpic.com',
  'pancakemail.com',
  'pjkls.com',
  'plexolan.de',
  'poczta.onet.pl',
  'politikerclub.de',
  'pooae.com',
  'pookmail.com',
  'privacy.net',
  'proxymail.eu',
  'prtnx.com',
  'punkass.com',
  'putthisinyourspamdatabase.com',
  'putthisinyourspamdatabase.com',
  'pwrby.com',
  'quickinbox.com',
  'rcpt.at',
  'receiveee.com',
  'recursor.net',
  'regbypass.comsafe-mail.net',
  'rejectmail.com',
  'rhyta.com',
  'rmqkr.net',
  'rppkn.com',
  'rtrtr.com',
  's0ny.net',
  'safe-mail.net',
  'safetymail.info',
  'safetypost.de',
  'sandelf.de',
  'saynotospams.com',
  'schafmail.de',
  'selfdestructingmail.com',
  'sendspamhere.de',
  'sharklasers.com',
  'shieldedmail.com',
  'shiftmail.com',
  'shitmail.me',
  'shitware.nl',
  'shmeriously.com',
  'shortmail.net',
  'sibmail.com',
  'sinnlos-mail.de',
  'slapsfromlastnight.com',
  'slaskpost.se',
  'slopsbox.com',
  'slushmail.com',
  'smap.4nmv.ru',
  'smashmail.de',
  'smellfear.com',
  'snakemail.com',
  'sneakemail.com',
  'snkmail.com',
  'sofimail.com',
  'solvemail.info',
  'spambog.com',
  'spambog.de',
  'spambog.ru',
  'spambooger.com',
  'spambox.info',
  'spambox.irishspringtours.com',
  'spambox.us',
  'spamcannon.com',
  'spamcannon.net',
  'spamcero.com',
  'spamcorptastic.com',
  'spamcowboy.com',
  'spamcowboy.net',
  'spamcowboy.org',
  'spamday.com',
  'spamex.com',
  'spamfree24.com',
  'spamfree24.de',
  'spamfree24.eu',
  'spamfree24.info',
  'spamfree24.net',
  'spamfree24.org',
  'spamgoes.com',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'spamherelots.com',
  'spamhereplease.com',
  'spamhippo.com',
  'spamhole.com',
  'spami.spam.co.za',
  'spaml.com',
  'spaml.de',
  'spammotel.com',
  'spamobox.com',
  'spamoff.de',
  'spamslicer.com',
  'spamspot.com',
  'spamthis.co.uk',
  'spamthisplease.com',
  'spamtrail.com',
  'spamtroll.net',
  'speed.1s.fr',
  'srilankahotel.com',
  'stinkefinger.net',
  'stop-my-spam.com',
  'stuffmail.de',
  'super-auswahl.de',
  'supergreatmail.com',
  'supermailer.jp',
  'superrito.com',
  'superstachel.de',
  'suremail.info',
  'tagyourself.com',
  'talkinator.com',
  'tapchicuoihoi.com',
  'teewars.org',
  'teleworm.com',
  'teleworm.us',
  'temp-mail.org',
  'temp-mail.ru',
  'tempalias.com',
  'tempe-mail.com',
  'tempemail.biz',
  'tempemail.com',
  'tempinbox.co.uk',
  'tempinbox.com',
  'tempmail.eu',
  'tempmaildemo.com',
  'tempmailer.com',
  'tempmailer.de',
  'tempomail.fr',
  'temporarily.de',
  'temporarioemail.com.br',
  'temporaryemail.net',
  'temporaryforwarding.com',
  'temporaryinbox.com',
  'temporarymailaddress.com',
  'tempthe.net',
  'thanksnospam.info',
  'thankyou2010.com',
  'thc.st',
  'thecloudindex.com',
  'thisisnotmyrealemail.com',
  'thismail.net',
  'throam.com',
  'throwam.com',
  'throwawayemailaddress.com',
  'tilien.com',
  'tinyurl.com',
  'tmail.ws',
  'tmailinator.com',
  'toiea.com',
  'tokem.co',
  'toomail.biz',
  'topranklist.de',
  'tradermail.info',
  'trash-amil.com',
  'trash-mail.at',
  'trash-mail.com',
  'trash-mail.de',
  'trash2009.com',
  'trashdevil.com',
  'trashemail.de',
  'trashmail.at',
  'trashmail.com',
  'trashmail.de',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashmail.ws',
  'trashmailer.com',
  'trashymail.com',
  'trashymail.net',
  'trbvm.com',
  'trialmail.de',
  'trillianpro.com',
  'tryalert.com',
  'turual.com',
  'twinmail.de',
  'twoweirdtricks.com',
  'tyldd.com',
  'ubismail.net',
  'uggsrock.com',
  'uinha.com',
  'umail.net',
  'upliftnow.com',
  'uplipht.com',
  'uroid.com',
  'us.af',
  'venompen.com',
  'veryrealemail.com',
  'viditag.com',
  'viewcastmedia.com',
  'viewcastmedia.net',
  'viewcastmedia.org',
  'vomoto.com',
  'vubby.com',
  'walala.org',
  'walkmail.net',
  'webemail.me',
  'webm4il.info',
  'webuser.in',
  'wh4f.org',
  'whatiaas.com',
  'whatpaas.com',
  'whatsaas.com',
  'whopy.com',
  'wilemail.com',
  'willselfdestruct.com',
  'winemaven.info',
  'wuzup.net',
  'wuzupmail.net',
  'www.e4ward.com',
  'www.gishpuppy.com',
  'www.mailinator.com',
  'wwwnew.eu',
  'x.ip6.li',
  'xagloo.com',
  'xemaps.com',
  'xents.com',
  'xmaily.com',
  'xoxy.net',
  'yapped.net',
  'yeah.net',
  'yep.it',
  'yogamaven.com',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'yourdomain.com',
  'yuurok.com',
  'z1p.biz',
  'za.com',
  'zehnminutenmail.de',
  'zetmail.com',
  'zippymail.info',
  'zoemail.org',
  'zoemail.net'
];

// Function to check if a domain is blocked
export const isDomainBlocked = (email: string): boolean => {
  if (!email || !email.includes('@')) return false;
  
  const domain = email.split('@')[1]?.toLowerCase();
  return blockedEmailDomains.includes(domain);
};

// Function to get the domain from an email
export const getEmailDomain = (email: string): string => {
  if (!email || !email.includes('@')) return '';
  return email.split('@')[1]?.toLowerCase() || '';
};
